import { useStateSelector } from 'hooks';

export const useCurrentPortal = () => {
  return useStateSelector((state) => state.settings.current_portal);
};
